"use strict";
// https://api.moonpay.com/v3/currencies?apiKey=pk_live_k6WSd0AaHVEXPV4WlBBrsvRMrAhRH
Object.defineProperty(exports, "__esModule", { value: true });
const currencies = [
    {
        id: "beb381fb-16d0-4949-890c-d78a626a0a8a",
        createdAt: "2020-03-14T11:51:49.199Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Australian Dollar",
        code: "aud",
        precision: 2,
        maxAmount: 16000,
        minAmount: 50,
        minBuyAmount: 50,
        maxBuyAmount: 16000,
        isSellSupported: false,
    },
    {
        id: "38b1f272-af74-4f61-a425-62219aea25d9",
        createdAt: "2021-11-30T12:59:02.328Z",
        updatedAt: "2023-05-05T12:07:14.132Z",
        type: "crypto",
        name: "Avalanche (C-Chain)",
        code: "avax_cchain",
        precision: 2,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 0.11,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 2,
        minSellAmount: 1.9,
        maxSellAmount: 170,
        metadata: {
            contractAddress: "0x0000000000000000000000000000000000000000",
            coinType: null,
            chainId: "43114",
            networkCode: "avalanche_c_chain",
        },
    },
    {
        id: "1faa158e-8433-4bae-bdb8-b5eb768f767d",
        createdAt: "2019-04-25T21:26:14.749Z",
        updatedAt: "2023-05-31T01:01:00.654Z",
        type: "crypto",
        name: "Basic Attention Token",
        code: "bat",
        precision: 0,
        maxAmount: 2000,
        minAmount: 212,
        minBuyAmount: 59.4,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: 212,
        maxSellAmount: 2000,
        metadata: {
            contractAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "b01f8f58-f915-491b-aadb-7ba6b966c861",
        createdAt: "2018-09-28T10:47:49.801Z",
        updatedAt: "2023-03-08T14:38:22.686Z",
        type: "crypto",
        name: "Bitcoin Cash",
        code: "bch",
        precision: 3,
        maxAmount: 10,
        minAmount: 0.05,
        minBuyAmount: null,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(bitcoincash:)?(q|p)[a-z0-9]{41}$",
        testnetAddressRegex: "^(bchtest:)?(q|p)[a-z0-9]{41}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 1,
        minSellAmount: 0.25,
        maxSellAmount: 100,
        metadata: {
            contractAddress: null,
            coinType: "145",
            chainId: null,
            networkCode: "bitcoin_cash",
        },
    },
    {
        id: "4372afed-961e-4c1c-9a8c-e922b2cb0ca5",
        createdAt: "2020-07-22T11:01:33.475Z",
        updatedAt: "2023-03-01T14:38:43.232Z",
        type: "fiat",
        name: "Bulgarian Lev",
        code: "bgn",
        precision: 2,
        maxAmount: 20000,
        minAmount: 60,
        minBuyAmount: 60,
        maxBuyAmount: 20000,
        isSellSupported: false,
    },
    {
        id: "c27c7038-7382-4ea9-a766-e37972f022e0",
        createdAt: "2019-02-22T11:36:00.093Z",
        updatedAt: "2023-05-31T11:24:15.860Z",
        type: "crypto",
        name: "Binance Coin (BEP-2)",
        code: "bnb",
        precision: 3,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 0.011,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(bnb1)[0-9a-z]{38}$",
        testnetAddressRegex: "^(tbnb1)[0-9a-z]{38}$",
        supportsAddressTag: true,
        addressTagRegex: "^[0-9A-Za-z\\\\-_]{1,120}$",
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: null,
            coinType: "714",
            chainId: null,
            networkCode: "bnb_chain",
        },
    },
    {
        id: "7d189686-5b3a-4bee-aef1-725e9826ce66",
        createdAt: "2020-10-21T10:59:01.854Z",
        updatedAt: "2022-09-27T07:18:11.779Z",
        type: "fiat",
        name: "Brazilian Real",
        code: "brl",
        precision: 2,
        maxAmount: 65000,
        minAmount: 150,
        minBuyAmount: 200,
        maxBuyAmount: 65000,
        isSellSupported: false,
    },
    {
        id: "a18a8d0b-502c-48b9-ab6b-e2638fba5862",
        createdAt: "2018-09-28T10:47:49.801Z",
        updatedAt: "2023-03-30T17:58:08.526Z",
        type: "crypto",
        name: "Bitcoin",
        code: "btc",
        precision: 5,
        maxAmount: 0.2,
        minAmount: 0.001,
        minBuyAmount: 0.001,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^(bc1)[0-9A-Za-z]{39,59}$",
        testnetAddressRegex: "^(tb1|[2mn])[a-zA-HJ-NP-Z0-9]{25,39}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 1,
        minSellAmount: 0.0015,
        maxSellAmount: 0.6,
        metadata: {
            contractAddress: null,
            coinType: "0",
            chainId: null,
            networkCode: "bitcoin",
        },
    },
    {
        id: "9efa0420-9f96-4b9c-a9ce-dee8e267ddcf",
        createdAt: "2020-03-14T11:51:49.199Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Canadian Dollar",
        code: "cad",
        precision: 2,
        maxAmount: 16000,
        minAmount: 50,
        minBuyAmount: 50,
        maxBuyAmount: 16000,
        isSellSupported: false,
    },
    {
        id: "8508c57b-2720-4cb9-8d9f-2853ab52a091",
        createdAt: "2020-04-22T16:15:05.763Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Swiss Franc",
        code: "chf",
        precision: 2,
        maxAmount: 11000,
        minAmount: 30,
        minBuyAmount: 30,
        maxBuyAmount: 11000,
        isSellSupported: false,
    },
    {
        id: "5465e43b-2596-48cc-b8de-b6de57421241",
        createdAt: "2020-07-22T11:30:57.919Z",
        updatedAt: "2023-03-01T14:38:43.341Z",
        type: "fiat",
        name: "Chinese Yuan",
        code: "cny",
        precision: 2,
        maxAmount: 82000,
        minAmount: 230,
        minBuyAmount: 230,
        maxBuyAmount: 82000,
        isSellSupported: false,
    },
    {
        id: "32a496d4-755f-4f2a-91e1-2ce31fbe6c34",
        createdAt: "2020-08-17T12:13:59.362Z",
        updatedAt: "2023-04-12T22:50:01.218Z",
        type: "crypto",
        name: "Compound",
        code: "comp",
        precision: 3,
        maxAmount: 2000,
        minAmount: 212,
        minBuyAmount: null,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: false,
        notAllowedUSStates: [],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: 212,
        maxSellAmount: 2000,
        metadata: {
            contractAddress: "0xc00e94cb662c3520282e6f5717214004a7f26888",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "2b7d4064-75fa-43c0-8fac-de57ea2f6980",
        createdAt: "2020-07-22T11:12:31.219Z",
        updatedAt: "2023-04-21T15:36:42.244Z",
        type: "fiat",
        name: "Colombian Peso",
        code: "cop",
        precision: 0,
        maxAmount: 42500000,
        minAmount: 130000,
        minBuyAmount: 130000,
        maxBuyAmount: 42500000,
        isSellSupported: false,
    },
    {
        id: "a865a512-0f4a-4147-9de2-4ed87717156c",
        createdAt: "2020-07-22T11:12:41.131Z",
        updatedAt: "2023-03-01T14:38:42.956Z",
        type: "fiat",
        name: "Czech Koruna",
        code: "czk",
        precision: 2,
        maxAmount: 260000,
        minAmount: 750,
        minBuyAmount: 750,
        maxBuyAmount: 260000,
        isSellSupported: false,
    },
    {
        id: "b3e4e8f1-42b3-405b-994a-2bd1bd22786b",
        createdAt: "2020-07-22T11:24:18.502Z",
        updatedAt: "2023-03-01T14:38:43.286Z",
        type: "fiat",
        name: "Danish Krone",
        code: "dkk",
        precision: 2,
        maxAmount: 75000,
        minAmount: 220,
        minBuyAmount: 220,
        maxBuyAmount: 75000,
        isSellSupported: false,
    },
    {
        id: "af950192-8e01-4a84-9807-27f16d88450e",
        createdAt: "2020-07-17T11:54:33.126Z",
        updatedAt: "2023-05-31T11:26:57.172Z",
        type: "crypto",
        name: "Dogecoin",
        code: "doge",
        precision: 0,
        maxAmount: 2000,
        minAmount: 20,
        minBuyAmount: 88,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(D|A|9)[a-km-zA-HJ-NP-Z1-9]{33,34}$",
        testnetAddressRegex: "^n{1}[a-km-zA-HJ-NP-Z1-9]{33,34}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: 20,
        maxSellAmount: 2000,
        metadata: {
            contractAddress: null,
            coinType: "3",
            chainId: null,
            networkCode: "dogecoin",
        },
    },
    {
        id: "1c6c3ff1-a796-4724-ae4c-449d1ef1897d",
        createdAt: "2020-07-22T11:24:31.795Z",
        updatedAt: "2023-03-01T14:38:43.395Z",
        type: "fiat",
        name: "Dominican Peso",
        code: "dop",
        precision: 2,
        maxAmount: 680000,
        minAmount: 2000,
        minBuyAmount: 2000,
        maxBuyAmount: 680000,
        isSellSupported: false,
    },
    {
        id: "83e44c86-d0d8-4896-a3f7-49dabe3fd635",
        createdAt: "2020-09-08T13:54:40.621Z",
        updatedAt: "2023-04-30T17:36:00.644Z",
        type: "crypto",
        name: "Polkadot",
        code: "dot",
        precision: 2,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 1.65,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(1)[0-9a-z-A-Z]{44,50}$",
        testnetAddressRegex: "^(1)[0-9a-z-A-Z]{44,50}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: null,
            coinType: null,
            chainId: null,
            networkCode: "polkadot",
        },
    },
    {
        id: "bdbcdf09-9896-49ca-bd5c-d1fb33f371bd",
        createdAt: "2020-07-22T11:24:37.545Z",
        updatedAt: "2023-03-01T14:38:43.450Z",
        type: "fiat",
        name: "Egyptian Pound",
        code: "egp",
        precision: 2,
        maxAmount: 185000,
        minAmount: 550,
        minBuyAmount: 550,
        maxBuyAmount: 185000,
        isSellSupported: false,
    },
    {
        id: "8d305f63-1fd7-4e01-a220-8445e591aec4",
        createdAt: "2018-09-28T10:47:49.801Z",
        updatedAt: "2023-03-08T14:38:22.686Z",
        type: "crypto",
        name: "Ethereum",
        code: "eth",
        precision: 4,
        maxAmount: 3,
        minAmount: 0.01,
        minBuyAmount: 0.01078,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 12,
        minSellAmount: 0.025,
        maxSellAmount: 8.5,
        metadata: {
            contractAddress: "0x0000000000000000000000000000000000000000",
            coinType: "60",
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "71435a8d-211c-4664-a59e-2a5361a6c5a7",
        createdAt: "2019-04-22T15:12:07.861Z",
        updatedAt: "2023-05-18T17:48:41.097Z",
        type: "fiat",
        name: "Euro",
        code: "eur",
        precision: 2,
        maxAmount: 10000,
        minAmount: 30,
        minBuyAmount: 30,
        maxBuyAmount: 10000,
        isSellSupported: true,
    },
    {
        id: "6f424585-8936-4eb1-b01e-443fb306d1f5",
        createdAt: "2019-04-30T16:23:52.178Z",
        updatedAt: "2023-05-19T16:48:48.817Z",
        type: "fiat",
        name: "Pound Sterling",
        code: "gbp",
        precision: 2,
        maxAmount: 9000,
        minAmount: 30,
        minBuyAmount: 30,
        maxBuyAmount: 9000,
        isSellSupported: true,
    },
    {
        id: "a080db62-29b4-44d2-ad40-7fe037f72e5e",
        createdAt: "2020-07-22T11:24:45.564Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Hong Kong Dollar",
        code: "hkd",
        precision: 2,
        maxAmount: 90000,
        minAmount: 280,
        minBuyAmount: 280,
        maxBuyAmount: 90000,
        isSellSupported: false,
    },
    {
        id: "a10ed157-1b7e-47ad-a3c9-fe6ae1ffff08",
        createdAt: "2020-07-22T11:25:00.354Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Indonesian Rupiah",
        code: "idr",
        precision: 2,
        maxAmount: 170000000,
        minAmount: 520000,
        minBuyAmount: 520000,
        maxBuyAmount: 170000000,
        isSellSupported: false,
    },
    {
        id: "9a15ddd9-eed5-42b3-aae3-7589ee736985",
        createdAt: "2020-04-22T16:06:39.532Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Israeli New Shekel",
        code: "ils",
        precision: 2,
        maxAmount: 40000,
        minAmount: 120,
        minBuyAmount: 120,
        maxBuyAmount: 40000,
        isSellSupported: false,
    },
    {
        id: "15173b02-e6d6-4776-86d7-05fb16c563e0",
        createdAt: "2020-08-13T17:07:26.436Z",
        updatedAt: "2023-03-01T14:38:43.122Z",
        type: "fiat",
        name: "Jordanian Dinar",
        code: "jod",
        precision: 3,
        maxAmount: 8000,
        minAmount: 25,
        minBuyAmount: 25,
        maxBuyAmount: 8000,
        isSellSupported: false,
    },
    {
        id: "b955eaa4-8618-402e-99d9-3ec4f479e608",
        createdAt: "2020-08-13T17:08:37.440Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Japanese Yen",
        code: "jpy",
        precision: 0,
        maxAmount: 1250000,
        minAmount: 4000,
        minBuyAmount: 4000,
        maxBuyAmount: 1250000,
        isSellSupported: false,
    },
    {
        id: "33c920d1-bdf0-42f6-aae1-397b92a459c5",
        createdAt: "2020-07-22T11:31:31.215Z",
        updatedAt: "2023-03-01T14:38:42.731Z",
        type: "fiat",
        name: "Kenyan Shilling",
        code: "kes",
        precision: 2,
        maxAmount: 1250000,
        minAmount: 4000,
        minBuyAmount: 4000,
        maxBuyAmount: 1250000,
        isSellSupported: false,
    },
    {
        id: "ab62cccc-7d7d-41df-9298-2828fd84959d",
        createdAt: "2020-08-13T17:10:21.008Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "South Korean Won",
        code: "krw",
        precision: 0,
        maxAmount: 12000000,
        minAmount: 40000,
        minBuyAmount: 40000,
        maxBuyAmount: 12000000,
        isSellSupported: false,
    },
    {
        id: "9e656712-f1b2-4ae6-bb94-724e0384b288",
        createdAt: "2020-08-13T17:11:29.045Z",
        updatedAt: "2023-03-01T14:38:43.011Z",
        type: "fiat",
        name: "Kuwaiti Dinar",
        code: "kwd",
        precision: 3,
        maxAmount: 3500,
        minAmount: 10,
        minBuyAmount: 10,
        maxBuyAmount: 3500,
        isSellSupported: false,
    },
    {
        id: "83b57eca-5e25-4bd6-89bd-e4bada573bdb",
        createdAt: "2020-07-22T11:25:21.253Z",
        updatedAt: "2023-03-01T14:38:42.789Z",
        type: "fiat",
        name: "Sri Lankan Rupee",
        code: "lkr",
        precision: 2,
        maxAmount: 2150000,
        minAmount: 7000,
        minBuyAmount: 7000,
        maxBuyAmount: 2150000,
        isSellSupported: false,
    },
    {
        id: "84bf7e0f-0a16-4486-8ba7-e80edcf5331e",
        createdAt: "2019-04-10T15:54:48.989Z",
        updatedAt: "2023-03-08T14:38:22.686Z",
        type: "crypto",
        name: "Litecoin",
        code: "ltc",
        precision: 3,
        maxAmount: 2000,
        minAmount: 20,
        minBuyAmount: 0.0022,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(L|M|3)[A-Za-z0-9]{33}$|^(ltc1)[0-9A-Za-z]{39}$",
        testnetAddressRegex: "^(L|M|3)[A-Za-z0-9]{33}$|^(tltc1)[0-9A-Za-z]{39}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 6,
        minSellAmount: 0.25,
        maxSellAmount: 20,
        metadata: {
            contractAddress: null,
            coinType: "2",
            chainId: null,
            networkCode: "litecoin",
        },
    },
    {
        id: "456bc2e4-0219-4a19-8cfb-46291079c91b",
        createdAt: "2020-07-22T11:25:31.668Z",
        updatedAt: "2023-03-01T14:38:43.504Z",
        type: "fiat",
        name: "Moroccan Dirham",
        code: "mad",
        precision: 2,
        maxAmount: 110000,
        minAmount: 320,
        minBuyAmount: 320,
        maxBuyAmount: 110000,
        isSellSupported: false,
    },
    {
        id: "34c3ed5f-0f60-497d-b31a-04065047aa2c",
        createdAt: "2021-07-01T15:26:23.848Z",
        updatedAt: "2023-05-31T11:26:11.915Z",
        type: "crypto",
        name: "Polygon (Polygon)",
        code: "matic_polygon",
        precision: 2,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: null,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: "0x0000000000000000000000000000000000000000",
            coinType: "966",
            chainId: "137",
            networkCode: "polygon",
        },
    },
    {
        id: "6e703a57-0edb-49cc-84bc-c4d60a650b63",
        createdAt: "2020-07-22T11:25:43.990Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Mexican Peso",
        code: "mxn",
        precision: 2,
        maxAmount: 260000,
        minAmount: 700,
        minBuyAmount: 700,
        maxBuyAmount: 260000,
        isSellSupported: false,
    },
    {
        id: "87043a85-435b-4371-b201-9a4e97dcbb3c",
        createdAt: "2020-07-22T11:31:40.535Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Malaysian Ringgit",
        code: "myr",
        precision: 2,
        maxAmount: 50000,
        minAmount: 150,
        minBuyAmount: 150,
        maxBuyAmount: 50000,
        isSellSupported: false,
    },
    {
        id: "239495d6-1cb3-4fd0-bbe2-d3f15bf5f2ad",
        createdAt: "2020-07-22T11:25:59.323Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Nigerian Naira",
        code: "ngn",
        precision: 2,
        maxAmount: 4500000,
        minAmount: 15000,
        minBuyAmount: 15000,
        maxBuyAmount: 4500000,
        isSellSupported: false,
    },
    {
        id: "82327c66-0f98-45fc-a212-b5bd709f9cc6",
        createdAt: "2020-04-22T16:12:52.173Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Norwegian Krone",
        code: "nok",
        precision: 2,
        maxAmount: 110000,
        minAmount: 300,
        minBuyAmount: 300,
        maxBuyAmount: 110000,
        isSellSupported: false,
    },
    {
        id: "1c9beb30-cabb-40d5-aa28-f2ae703a42c0",
        createdAt: "2020-07-22T11:26:08.063Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "New Zealand Dollar",
        code: "nzd",
        precision: 2,
        maxAmount: 18000,
        minAmount: 50,
        minBuyAmount: 50,
        maxBuyAmount: 18000,
        isSellSupported: false,
    },
    {
        id: "b8152935-cfeb-4e64-847e-2c29d888ebc9",
        createdAt: "2020-08-13T17:13:21.484Z",
        updatedAt: "2023-03-01T14:38:42.845Z",
        type: "fiat",
        name: "Omani Rial",
        code: "omr",
        precision: 3,
        maxAmount: 4300,
        minAmount: 15,
        minBuyAmount: 15,
        maxBuyAmount: 4300,
        isSellSupported: false,
    },
    {
        id: "52d550cd-13eb-4a1c-b279-b68268c528a0",
        createdAt: "2020-07-22T11:26:12.738Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Peruvian Sol",
        code: "pen",
        precision: 2,
        maxAmount: 40000,
        minAmount: 130,
        minBuyAmount: 130,
        maxBuyAmount: 40000,
        isSellSupported: false,
    },
    {
        id: "67b38247-8a2b-4614-a8fc-e078b3539cff",
        createdAt: "2020-07-22T11:26:20.252Z",
        updatedAt: "2023-03-01T14:38:42.901Z",
        type: "fiat",
        name: "Pakistani Rupee",
        code: "pkr",
        precision: 2,
        maxAmount: 1950000,
        minAmount: 5500,
        minBuyAmount: 5500,
        maxBuyAmount: 1950000,
        isSellSupported: false,
    },
    {
        id: "18dfd358-db55-43de-8660-826413bbc5ab",
        createdAt: "2020-04-22T16:13:11.842Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Polish Złoty",
        code: "pln",
        precision: 2,
        maxAmount: 45000,
        minAmount: 140,
        minBuyAmount: 140,
        maxBuyAmount: 45000,
        isSellSupported: false,
    },
    {
        id: "1fecf3b1-7743-4b2e-89a7-7e32e6c64d13",
        createdAt: "2020-07-22T11:26:27.677Z",
        updatedAt: "2023-03-01T14:38:43.177Z",
        type: "fiat",
        name: "Romanian Leu",
        code: "ron",
        precision: 2,
        maxAmount: 48000,
        minAmount: 150,
        minBuyAmount: 150,
        maxBuyAmount: 48000,
        isSellSupported: false,
    },
    {
        id: "56ce4136-1519-469d-90e0-4c9cc9ddbe98",
        createdAt: "2020-04-22T16:13:47.028Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Swedish Krona",
        code: "sek",
        precision: 2,
        maxAmount: 105000,
        minAmount: 300,
        minBuyAmount: 300,
        maxBuyAmount: 105000,
        isSellSupported: false,
    },
    {
        id: "7f4d75df-0059-4950-ab31-fb2b83a4b23b",
        createdAt: "2021-10-27T20:08:12.206Z",
        updatedAt: "2023-06-02T01:01:00.813Z",
        type: "crypto",
        name: "Shiba Inu (ERC-20)",
        code: "shib",
        precision: 0,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 1536563.6,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "LA", "NY", "RI", "TX", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "b0eaa8d9-b197-4be1-8703-c0d42919bf57",
        createdAt: "2020-07-22T11:27:28.972Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Thai Baht",
        code: "thb",
        precision: 2,
        maxAmount: 370000,
        minAmount: 1200,
        minBuyAmount: 1200,
        maxBuyAmount: 370000,
        isSellSupported: false,
    },
    {
        id: "d3c98192-a872-4958-bc91-7a8434acc1d1",
        createdAt: "2020-07-22T11:27:34.419Z",
        updatedAt: "2022-11-30T11:48:03.108Z",
        type: "fiat",
        name: "Turkish Lira",
        code: "try",
        precision: 2,
        maxAmount: 80000,
        minAmount: 400,
        minBuyAmount: 400,
        maxBuyAmount: 80000,
        isSellSupported: false,
    },
    {
        id: "15618cb8-74ff-4af5-88cf-13c88271bbf3",
        createdAt: "2020-07-22T11:27:41.600Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Taiwan Dollar",
        code: "twd",
        precision: 2,
        maxAmount: 340000,
        minAmount: 1000,
        minBuyAmount: 1000,
        maxBuyAmount: 340000,
        isSellSupported: false,
    },
    {
        id: "3140e0a0-5a54-4ee4-8b5c-39c7bbfa1643",
        createdAt: "2020-10-20T17:22:24.216Z",
        updatedAt: "2023-06-01T01:01:00.833Z",
        type: "crypto",
        name: "Uniswap",
        code: "uni",
        precision: 2,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 2.552,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: false,
        notAllowedUSStates: [],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "edd81f1f-f735-4692-b410-6def107f17d2",
        createdAt: "2019-04-29T16:55:28.647Z",
        updatedAt: "2023-03-06T10:11:49.284Z",
        type: "fiat",
        name: "US Dollar",
        code: "usd",
        precision: 2,
        maxAmount: 12000,
        minAmount: 30,
        minBuyAmount: 30,
        maxBuyAmount: 12000,
        isSellSupported: true,
    },
    {
        id: "aaefa32f-161b-42c8-8115-debcbf3d6a2d",
        createdAt: "2019-05-17T18:24:45.206Z",
        updatedAt: "2023-03-13T14:57:46.802Z",
        type: "crypto",
        name: "USD Coin (ERC-20)",
        code: "usdc",
        precision: 2,
        maxAmount: 10000,
        minAmount: 30,
        minBuyAmount: null,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 11,
        minSellAmount: 20,
        maxSellAmount: 10000,
        metadata: {
            contractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            coinType: "60",
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "3693a9c0-7b24-4e48-a8a7-75021ad6e26a",
        createdAt: "2019-07-04T08:37:10.847Z",
        updatedAt: "2023-03-08T14:38:22.686Z",
        type: "crypto",
        name: "Tether (ERC-20)",
        code: "usdt",
        precision: 2,
        maxAmount: 10000,
        minAmount: 30,
        minBuyAmount: null,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "NY", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 12,
        minSellAmount: 20,
        maxSellAmount: 10000,
        metadata: {
            contractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
            coinType: "60",
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "7c73366c-7bc0-48f0-add2-ad625eb3622c",
        createdAt: "2023-02-20T15:20:59.357Z",
        updatedAt: "2023-03-05T13:20:00.865Z",
        type: "crypto",
        name: "Verse (ERC-20)",
        code: "verse",
        precision: 4,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 25000,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: "",
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: false,
        notAllowedUSStates: [],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: "0x249cA82617eC3DfB2589c4c17ab7EC9765350a18",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "0c6284be-f5e0-4f27-9aae-ea6aa6bb42e2",
        createdAt: "2020-08-13T17:15:47.092Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "Vietnamese Dong",
        code: "vnd",
        precision: 0,
        maxAmount: 250000000,
        minAmount: 850000,
        minBuyAmount: 850000,
        maxBuyAmount: 250000000,
        isSellSupported: false,
    },
    {
        id: "fec58310-c00f-4874-8509-2ccbf4249eb1",
        createdAt: "2020-09-28T12:50:08.835Z",
        updatedAt: "2023-06-02T04:15:00.872Z",
        type: "crypto",
        name: "Wrapped Bitcoin",
        code: "wbtc",
        precision: 4,
        maxAmount: null,
        minAmount: null,
        minBuyAmount: 0.00048,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        testnetAddressRegex: "^(0x)[0-9A-Fa-f]{40}$",
        supportsAddressTag: false,
        addressTagRegex: null,
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: false,
        notAllowedUSStates: [],
        notAllowedCountries: [],
        confirmationsRequired: null,
        minSellAmount: null,
        maxSellAmount: null,
        metadata: {
            contractAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
            coinType: null,
            chainId: "1",
            networkCode: "ethereum",
        },
    },
    {
        id: "c8b1ef20-3703-4a66-9ea1-c13ce0d893bf",
        createdAt: "2019-04-10T15:58:46.394Z",
        updatedAt: "2023-03-08T14:38:22.686Z",
        type: "crypto",
        name: "Stellar",
        code: "xlm",
        precision: 0,
        maxAmount: 2000,
        minAmount: 20,
        minBuyAmount: 44,
        maxBuyAmount: null,
        isSellSupported: true,
        addressRegex: "^G[A-D]{1}[A-Z2-7]{54}$",
        testnetAddressRegex: "^G[A-D]{1}[A-Z2-7]{54}$",
        supportsAddressTag: true,
        addressTagRegex: "^[0-9A-Za-z]{1,28}$",
        supportsTestMode: true,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: true,
        notAllowedUSStates: ["HI", "NY", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 1,
        minSellAmount: 200,
        maxSellAmount: 100000,
        metadata: {
            contractAddress: null,
            coinType: "148",
            chainId: null,
            networkCode: "stellar",
        },
    },
    {
        id: "d64b5e09-3d1b-452d-ab28-478c4190de7d",
        createdAt: "2019-04-10T15:55:51.649Z",
        updatedAt: "2023-05-31T11:15:20.287Z",
        type: "crypto",
        name: "XRP",
        code: "xrp",
        precision: 2,
        maxAmount: 2000,
        minAmount: 20,
        minBuyAmount: 33,
        maxBuyAmount: null,
        isSellSupported: false,
        addressRegex: "^r[1-9A-HJ-NP-Za-km-z]{25,34}$",
        testnetAddressRegex: "^r[1-9A-HJ-NP-Za-km-z]{25,34}$",
        supportsAddressTag: true,
        addressTagRegex: "^((?!0)[0-9]{1,19})$",
        supportsTestMode: false,
        supportsLiveMode: true,
        isSuspended: false,
        isSupportedInUS: false,
        notAllowedUSStates: ["HI", "NY", "RI", "VI"],
        notAllowedCountries: [],
        confirmationsRequired: 1,
        minSellAmount: 70,
        maxSellAmount: 6600,
        metadata: {
            contractAddress: null,
            coinType: "144",
            chainId: null,
            networkCode: "ripple",
        },
    },
    {
        id: "863cd8f3-e5d6-4ae8-b520-9cbb0e7713ad",
        createdAt: "2020-03-14T11:51:49.199Z",
        updatedAt: "2022-08-16T13:42:26.618Z",
        type: "fiat",
        name: "South African Rand",
        code: "zar",
        precision: 2,
        maxAmount: 195000,
        minAmount: 550,
        minBuyAmount: 550,
        maxBuyAmount: 195000,
        isSellSupported: false,
    },
];
exports.default = currencies;
//# sourceMappingURL=currencies.js.map